import React from 'react';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';
import {TBodyProps} from '@views/knowledge/.types';

const Body = React.lazy(() => import('@views/knowledge/components/Body'));

export default function LazyBody(props: TBodyProps) {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <Body {...props}/>
    </React.Suspense>;
}
